module.exports = __webpack_public_path__ + "media/images/uva-2-f4fcb2d8626c3514a30acf672b024816.jpg";